import { WithStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import blueGrey from '@material-ui/core/colors/blueGrey';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Fab from '@material-ui/core/Fab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import InputLabel from '@material-ui/core/InputLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Stepper from '@material-ui/core/Stepper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import SvgIcon from '@material-ui/core/SvgIcon';
import Typography from '@material-ui/core/Typography';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DoneIcon from '@material-ui/icons/Done';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as Stickyfill from 'stickyfilljs';

import {
	clearElearingUpdateResult,
	getScoringButtonClickResult,
	IIndexTreeItem,
	IScoringButtonClickSaveResult,
	setELearningNextOrTopITem,
	setELearningReservedTreeItem,
	setELearningTreeItemTestLog,
	setNotMarkCompleteFlg,
} from '../actions/eLearning';
import * as Actions from '../actions/testForm';
import TextField, { TextFieldProps } from '../components/TextFieldNoSubmit';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ELearningScenarioFactory, {
	IFetchELearningProgressParam,
	IFetchELearningTreeParam,
} from '../scenario/ELearningScenarioFactory';
import ScenarioFactory, {
	IFetchTestParam,
	IMarkTestParms,
} from '../scenario/TestFormScenarioFactory';
import FormControl from '../utils/FormControlWrapper';
import { isMobile } from '../utils/MobileCheck';
import { getLinkUrl } from '../utils/ReplaceLinkUrl';
import { IELearningCommonProps } from './ELearning';

import SiteConfig from '../site.config.json';

import { showELearningFinishDialog } from '../actions/eLearning';

const styles = (theme: Theme) =>
	createStyles({
		attachment: {
			height: 'auto',
			minHeight: '32px',
			whiteSpace: 'normal',
		},
		buttons: {
			marginTop: theme.spacing(2),
		},
		checkbox: {
			height: 'auto',
			paddingLeft: '42px',
			whiteSpace: 'pre-wrap',
			wordBreak: 'break-word',
		},
		group: {
			marginBottom: theme.spacing(2),
			marginTop: theme.spacing(2),
			padding: theme.spacing(1),
		},
		groupTitle: {
			flexGrow: 1,
			fontSize: '1.2rem',
		},
		minWidth: {
			minWidth: '200px',
		},
		paddingLeft: {
			paddingLeft: '42px',
		},
		paper: {
			marginTop: theme.spacing(2),
		},
		question: {
			borderColor: blueGrey[100],
			borderRadius: '1em',
			borderStyle: 'solid',
			marginTop: theme.spacing(1),
			overflowWrap: 'break-word',
			padding: theme.spacing(1),
			wordWrap: 'break-word',
		},
		questionImage: {
			maxWidth: '100%',
		},
		questionImageContainer: {
			display: 'flex',
			justifyContent: 'center',
		},
		questionTitle: {
			fontSize: '1rem',
			marginBottom: theme.spacing(2),
		},
		root: {
			padding: theme.spacing(2),
			wordBreak: 'break-word',
		},
		selectAndRadio: {
			height: 'auto',
			whiteSpace: 'pre-wrap',
			width: '100%',
			wordBreak: 'break-word',
		},
		sign: {
			color: green[500],
			left: theme.spacing(-4),
			position: 'absolute',
		},
		signControl: {
			marginTop: theme.spacing(2),
			textAlign: 'center',
		},
		status: {
			backgroundColor: 'rgba(55,71,79,0.8)',
			borderBottomLeftRadius: '1em',
			borderTopLeftRadius: '1em',
			color: grey[50],
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
		},
		statusContainer: {
			marginTop: theme.spacing(1),
			position: 'sticky',
			top: theme.spacing(1),
			zIndex: 10,
		},
		statusItem: {
			padding: theme.spacing(1),
		},
		step: {
			position: 'relative',
		},
		table: {
			marginBottom: theme.spacing(2),
			marginTop: theme.spacing(2),
			padding: theme.spacing(3),
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		width: {
			width: '100%',
		},
	});

// @material-ui/icons/... だとサイズがあわないので自作
const StarsIcon: React.FC = props => (
	<SvgIcon color="primary">
		<path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zM16.23 18L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
	</SvgIcon>
);

interface IState {
	answers: { [questionID: string]: string[] };
	disableMarkButton: boolean;
	selectedGroup: number;
	selectedQuestion: number;
	saveResultSnackbar: boolean;
	openMarkConfirm: boolean;
	open5Minutes: 'yet' | 'doing' | 'done';
	openTimeup: boolean;
	secondsToGo: number;
	signedQuestionIDs: Set<string>;
	openNoticeLaterOn: boolean;

	careerID: string;
	classID: string;
	currentTreeItemID: string;
}

/**
 * テスト実施コンポーネント
 */
class ELearningTestForm extends React.Component<IProps, IState> {
	protected forms: {
		[questionID: string]: { [index: number]: HTMLFormElement };
	};
	protected startAt: Date;
	protected timer?: number;
	protected preBtnDisabled: boolean;
	protected nextBtnDisabled: boolean;

	constructor(props: IProps) {
		super(props);

		this.state = {
			answers: {},
			disableMarkButton: false,
			open5Minutes: 'yet',
			openMarkConfirm: false,
			openNoticeLaterOn: false,
			openTimeup: false,
			saveResultSnackbar: false,
			secondsToGo: 0,
			selectedGroup: 0,
			selectedQuestion: 0,
			signedQuestionIDs: new Set(),

			careerID: '',
			classID: '',
			currentTreeItemID: '',
		};
		this.forms = {};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillReceiveProps(nextProps: IProps) {
		if (this.props.groups === nextProps.groups) {
			return;
		}

		// 回答データの初期化
		// サーバからのデータに回答が入っていた場合は反映する
		for (const group of nextProps.groups) {
			for (const question of group.questions) {
				if (question.checked) {
					this.state.signedQuestionIDs.add(question.questionID);
				}
				this.state.answers[question.questionID] = [];
				if (question.questionKind === Actions.QuestionKind.CHECK) {
					// check
					for (const a of question.answers) {
						const answer = a as Actions.ICheckAnswer;
						if (answer.selected) {
							this.state.answers[question.questionID].push(
								answer.answerID
							);
						}
					}
					continue;
				}
				if (question.questionKind === Actions.QuestionKind.TEXT) {
					// text
					for (const a of question.answers) {
						const answer = a as Actions.ITextAnswer;
						const s = answer.answerText ? answer.answerText : '';
						this.state.answers[question.questionID].push(s);
					}
					continue;
				}
				// radioまたはselect
				for (const a of question.answers) {
					const answer = a as
						| Actions.IRadioAnswer
						| Actions.ISelectAnswer;
					const s = answer.selectedAnswerID
						? answer.selectedAnswerID
						: '';
					this.state.answers[question.questionID].push(s);
				}
			}
		}

		this.setState({
			disableMarkButton: false,
			selectedGroup: 0,
			selectedQuestion: 0,
		});
		this.forms = {};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.props.onRef(this);
		this.fetch();
		if (this.props.outOfPeriodFlg) {
			return;
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.currentTreeItem || !this.props.currentTreeItem) {
			return;
		}
		if (this.props.outOfPeriodFlg) {
			return;
		}

		if (prevProps.timeLimit === 0 && this.props.timeLimit !== 0) {
			// timeLimitが0→0以外になったらタイマ起動
			this.startCountdown();
		}

		if (
			prevProps.careerID === this.props.careerID &&
			prevProps.classID === this.props.classID &&
			prevProps.currentTreeItem.id === this.props.currentTreeItem.id
		) {
			return;
		}
		// テストから違うテストに遷移したときここにくる
		this.endCountdown();
		this.props.setNotMarkCompleteFlg();
		this.fetch();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		if (this.timer !== undefined) {
			clearTimeout(this.timer);
		}
		this.props.clearTestFormParams();
		this.props.getScoringButtonClickResult(undefined);
	}

	public render() {
		if (!this.props.currentTreeItem) {
			return;
		}
		if (!this.props.groups || !(this.props.groups.length > 0)) {
			return <div />;
		}

		const { classes } = this.props;

		let secondsToGoElement;
		if (this.props.timeLimit !== 0) {
			secondsToGoElement = (
				<React.Fragment>
					<Typography variant="caption" color="inherit">
						{i18n.t('ELearningTestForm_0001', {
							timeLimit: this.secondsToStrings(
								this.props.timeLimit * 60
							),
						})}
					</Typography>
					<Typography variant="caption" color="inherit">
						{i18n.t('ELearningTestForm_0002', {
							secondsToGo: this.secondsToStrings(
								this.state.secondsToGo
							),
						})}
					</Typography>
				</React.Fragment>
			);
		}

		// 回答進捗率
		let denominator = 0;
		let numerator = 0;
		for (const group of this.props.groups) {
			for (const question of group.questions) {
				denominator++;
				if (this.isAnswered(question)) {
					numerator++;
				}
			}
		}
		const completed = (numerator / denominator) * 100;
		const progressText = i18n.t('ELearningTestForm_0003', {
			numerator,
			// tslint:disable-next-line:object-literal-sort-keys
			denominator,
		});

		return (
			<React.Fragment>
				<Grid
					container={true}
					justify="flex-end"
					className={classes.statusContainer}
					ref={(el: HTMLDivElement) => el && Stickyfill.add(el)}
				>
					<Grid item={true} xs={true} />
					<Grid item={true}>
						<Grid
							container={true}
							alignItems="center"
							className={classes.status}
						>
							<Grid
								item={true}
								className={classes.statusItem}
								style={{ width: '100px' }}
							>
								<LinearProgress
									variant="determinate"
									value={completed}
								/>
							</Grid>
							<Grid item={true} className={classes.statusItem}>
								<Typography color="inherit">
									{progressText}
								</Typography>
							</Grid>
							{secondsToGoElement && (
								<Grid
									item={true}
									className={classes.statusItem}
								>
									{secondsToGoElement}
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>

				{this.props.currentTreeItem.displayStyle === 0 ? (
					<this.SinglePage />
				) : (
					<this.MultiPage />
				)}

				<this.Dialogs />
			</React.Fragment>
		);
	}

	protected Dialogs: React.FC = props => {
		return (
			<React.Fragment>
				<Dialog
					open={this.state.open5Minutes === 'doing'}
					onClose={this.handleClose5Minutes}
				>
					<DialogTitle id="alert-5minutes">
						{i18n.t('ELearningTestForm_0004')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-5minutes">
							{i18n.t('ELearningTestForm_0005')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleClose5Minutes}
							color="primary"
						>
							{i18n.t('ELearningTestForm_0006')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openTimeup}
					onClose={this.handleTimeup}
				>
					<DialogTitle id="alert-5minutes">
						{i18n.t('ELearningTestForm_0007')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-5minutes">
							{i18n.t('ELearningTestForm_0008')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleTimeup} color="primary">
							{i18n.t('ELearningTestForm_0009')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openNoticeLaterOn}
					onClose={this.handleCloseNoticeLaterOn}
				>
					<DialogTitle id="alert-mark-after">
						{i18n.t('ELearningTestForm_0010')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-mark-after">
							{i18n.t('ELearningTestForm_0011')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseNoticeLaterOn}
							color="primary"
						>
							{i18n.t('ELearningTestForm_0012')}
						</Button>
					</DialogActions>
				</Dialog>
			</React.Fragment>
		);
	};

	/**
	 * 全問一ページ形式の描画
	 */
	protected SinglePage: React.FC = props => {
		if (!this.props.currentTreeItem) {
			return <React.Fragment />;
		}
		const { classes, groups } = this.props;
		const groupQuestion = this.props.groups[this.state.selectedGroup];
		const { selectedGroup, selectedQuestion } = this.state;
		const disablePre = selectedGroup === 0 && selectedQuestion === 0;
		const disableNex =
			selectedGroup === this.props.groups.length - 1 &&
			selectedQuestion === groupQuestion.questions.length - 1;
		this.preBtnDisabled = disablePre;
		this.nextBtnDisabled = disableNex;
		this.props.updateState();

		return (
			<div className={classes.root}>
				{groups.map(group => {
					return <this.Group key={group.groupTitle} group={group} />;
				})}
				<this.Buttons />
			</div>
		);
	};

	/**
	 * 一問一ページ形式の描画
	 */
	protected MultiPage: React.FC = props => {
		if (!this.props.currentTreeItem) {
			return <React.Fragment />;
		}
		const { classes, questionGroupDisplay } = this.props;
		const group = this.props.groups[this.state.selectedGroup];
		const question = group.questions[this.state.selectedQuestion];
		const { selectedGroup, selectedQuestion } = this.state;
		const disablePre = selectedGroup === 0 && selectedQuestion === 0;
		const disableNex =
			selectedGroup === this.props.groups.length - 1 &&
			selectedQuestion === group.questions.length - 1;
		this.preBtnDisabled = disablePre;
		this.nextBtnDisabled = disableNex;
		this.props.updateState();
		return (
			<div className={classes.root}>
				<Grid container={true} spacing={1}>
					<Grid item={true} xs={3}>
						<Paper className={classes.table}>
							<this.Table />
						</Paper>
					</Grid>
					<Grid item={true} xs={9}>
						{questionGroupDisplay && (
							<Typography
								variant="h6"
								className={classes.groupTitle}
								gutterBottom={true}
							>
								{group.groupTitle}
							</Typography>
						)}
						<this.Question question={question} />
						<this.Buttons />
					</Grid>
				</Grid>
			</div>
		);
	};

	/**
	 * 前に戻るハンドラ
	 */
	protected handlePrev = () => {
		if (this.preBtnDisabled) {
			this.props.handlePrev();
			return;
		}
		if (this.props.currentTreeItem) {
			if (this.props.currentTreeItem.displayStyle === 0) {
				this.props.handlePrev();
				return;
			}
		}
		const { selectedGroup, selectedQuestion } = this.state;
		if (selectedQuestion > 0) {
			this.setState({
				selectedQuestion: selectedQuestion - 1,
			});
			return;
		}
		const preGroup = selectedGroup - 1;
		this.setState({
			selectedGroup: preGroup,
			selectedQuestion: this.props.groups[preGroup].questions.length - 1,
		});
	};

	/**
	 * 次へハンドラ
	 */
	protected handleNext = () => {
		if (this.nextBtnDisabled) {
			this.props.handleNext();
			return;
		}
		if (this.props.currentTreeItem) {
			if (this.props.currentTreeItem.displayStyle === 0) {
				this.props.handleNext();
				return;
			}
		}
		const { selectedGroup, selectedQuestion } = this.state;
		const group = this.props.groups[selectedGroup];

		if (selectedQuestion < group.questions.length - 1) {
			this.setState({
				selectedQuestion: selectedQuestion + 1,
			});
			return;
		}
		const nexGroup = selectedGroup + 1;
		this.setState({
			selectedGroup: nexGroup,
			selectedQuestion: 0,
		});
	};

	/**
	 * 採点ボタン、一時保存ボタン
	 */
	protected Buttons: React.FC = props => (
		<Grid
			container={true}
			justify="center"
			spacing={3}
			className={this.props.classes.buttons}
		>
			<Grid item={true}>
				<Fab
					color="primary"
					variant="extended"
					size="large"
					onClick={this.handleMarkTest}
					disabled={this.state.disableMarkButton}
				>
					{i18n.t('ELearningTestForm_0013')}
				</Fab>
			</Grid>
			<Dialog
				open={this.state.openMarkConfirm}
				onClose={this.handleCloseConfirmMark}
				aria-labelledby="simple-dialog-title"
			>
				<DialogTitle id="alert-dialog-slide-title">
					{i18n.t('ELearningTestForm_0014')}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						{i18n.t('ELearningTestForm_0015')}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleStartMark} color="primary">
						{i18n.t('ELearningTestForm_0016')}
					</Button>
					<Button onClick={this.handleCloseConfirmMark}>
						{i18n.t('ELearningTestForm_0017')}
					</Button>
				</DialogActions>
			</Dialog>
			{this.props.displayTmpSaveBtn && (
				<Grid item={true}>
					<Fab
						color="default"
						variant="extended"
						size="large"
						onClick={this.handleSaveTest}
						disabled={this.state.disableMarkButton}
					>
						{i18n.t('ELearningTestForm_0018')}
					</Fab>
					<Snackbar
						anchorOrigin={{
							horizontal: 'left',
							vertical: 'bottom',
						}}
						open={this.state.saveResultSnackbar}
						autoHideDuration={6000}
						onClose={this.handleSaveResultSnackbarClose}
						ContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={
							<span id="message-id">
								{i18n.t('ELearningTestForm_0019')}
							</span>
						}
					/>
				</Grid>
			)}
		</Grid>
	);

	/**
	 * 一問一ページ形式の見出し部分
	 */
	protected Table: React.FC = props => {
		const { classes, groups, questionGroupDisplay } = this.props;
		const { selectedGroup, selectedQuestion } = this.state;

		return (
			<React.Fragment>
				{groups.map((group, i) => {
					const activeStep =
						i === selectedGroup ? selectedQuestion : -1;
					return (
						<div key={i}>
							{questionGroupDisplay && (
								<Typography
									variant="h6"
									className={classes.groupTitle}
								>
									{group.groupTitle}
								</Typography>
							)}
							<Stepper
								activeStep={activeStep}
								nonLinear={true}
								orientation="vertical"
							>
								{group.questions.map((question, j) => {
									const isSigned = this.state.signedQuestionIDs.has(
										question.questionID
									);
									if (!this.isAnswered(question)) {
										// 未回答時
										return (
											<Step
												key={question.questionNo}
												className={classes.step}
											>
												{isSigned && (
													<DoneIcon
														className={classes.sign}
													/>
												)}
												<StepButton
													onClick={this.handleSelectQuestion(
														i,
														j
													)}
												>
													<Hidden xsDown={true}>
														<Typography>
															{
																question.questionNo
															}
														</Typography>
													</Hidden>
												</StepButton>
											</Step>
										);
									}
									// 回答済み時
									return (
										<Step
											key={question.questionNo}
											className={classes.step}
											completed={true}
										>
											{isSigned && (
												<DoneIcon
													className={classes.sign}
												/>
											)}
											<StepButton
												onClick={this.handleSelectQuestion(
													i,
													j
												)}
												icon={<StarsIcon />}
											>
												<Hidden xsDown={true}>
													<Typography>
														{question.questionNo}
													</Typography>
												</Hidden>
											</StepButton>
										</Step>
									);
								})}
							</Stepper>
						</div>
					);
				})}
			</React.Fragment>
		);
	};

	/**
	 * テストグループ部分
	 */
	protected Group: React.FC<{ group: Actions.IGroup }> = props => {
		const { classes, questionGroupDisplay } = this.props;

		let answered = 0;
		for (const question of props.group.questions) {
			if (this.isAnswered(question)) {
				answered++;
			}
		}

		return (
			<ExpansionPanel defaultExpanded={true}>
				{questionGroupDisplay && (
					<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
						<Grid
							container={true}
							spacing={3}
							alignItems="flex-end"
						>
							<Grid item={true} xs={true}>
								{questionGroupDisplay && (
									<Typography
										variant="h6"
										className={classes.groupTitle}
										gutterBottom={true}
									>
										{props.group.groupTitle}
									</Typography>
								)}
							</Grid>
							<Grid item={true}>
								<Typography gutterBottom={true}>
									{i18n.t('ELearningTestForm_0024', {
										answered,
										length: props.group.questions.length,
									})}
								</Typography>
							</Grid>
						</Grid>
					</ExpansionPanelSummary>
				)}
				<ExpansionPanelDetails>
					<div style={{ width: '100%' }}>
						{props.group.questions.map(question => (
							<this.Question
								key={question.questionID}
								question={question}
							/>
						))}
					</div>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		);
	};

	/**
	 * 問題部分
	 */
	protected Question: React.FC<{ question: Actions.IQuestion }> = props => {
		const { classes } = this.props;
		const { question } = props;

		let answerForm: JSX.Element | null = null;
		switch (question.questionKind) {
			case Actions.QuestionKind.RADIO:
				answerForm = <this.AnswerFormRadio question={question} />;
				break;
			case Actions.QuestionKind.TEXT:
				answerForm = <this.AnswerFormText question={question} />;
				break;
			case Actions.QuestionKind.CHECK:
				answerForm = <this.AnswerFormCheck question={question} />;
				break;
			case Actions.QuestionKind.SELECT:
				answerForm = <this.AnswerFormSelect question={question} />;
				break;
		}
		const isMultiPage =
			(this.props.currentTreeItem &&
				this.props.currentTreeItem.displayStyle !== 0) ||
			false;
		const isSigned =
			isMultiPage &&
			this.state.signedQuestionIDs.has(question.questionID);

		const m = /^([^\s\d]+)(\d+)([^\s\d]+)$/.exec(question.questionScore);
		const questionScore = m
			? i18n.t(m[1], { ns: 'force' }) +
			  m[2] +
			  i18n.t(m[3], { ns: 'force' })
			: question.questionScore;

		const linkUrlParam: Actions.ILinkUrl = {
			careerID: this.props.careerID,
			lang: this.props.userAttr.lang,
			preview: this.props.preview,
			testID: !this.props.currentTreeItem
				? null
				: this.props.currentTreeItem.id,
		};
		return (
			<div className={classes.question}>
				<Grid container={true} spacing={3}>
					<Grid item={true} xs={true}>
						<Typography
							variant="h6"
							className={classes.questionTitle}
						>
							<span>{question.questionNo}</span>
							<br />
							{getLinkUrl(linkUrlParam, question.questionText)
								.split('\r\n')
								.map((item, i) => (
									<React.Fragment key={i}>
										<span
											dangerouslySetInnerHTML={{
												__html: item,
											}}
										/>
										<br />
									</React.Fragment>
								))}
						</Typography>
					</Grid>
					<Grid item={true}>
						<Typography>{questionScore}</Typography>
					</Grid>
				</Grid>
				{question.imageFilePath && (
					<div className={classes.questionImageContainer}>
						<img
							src={question.imageFilePath}
							className={classes.questionImage}
						/>
					</div>
				)}
				{!isMobile() &&
					question.references.map((r, i) => {
						const qid = question.questionID;
						const fnum = r.fileNum;
						return (
							<div key={i}>
								{i18n.t('ELearningTestForm_0020')}
								<Chip
									avatar={
										<Avatar>
											<CloudDownloadIcon />
										</Avatar>
									}
									label={r.displayFileName}
									clickable={true}
									onClick={this.handleFileChip(qid, fnum)}
									className={this.props.classes.attachment}
									classes={{
										label: this.props.classes.whiteSpace,
									}}
								/>
								<form
									method="POST"
									action={
										SiteConfig.tsqPath +
										'/tsq/pkg/action/el/testReferenceFileDownload.action'
									}
									ref={form =>
										this.addFileForm(
											qid,
											fnum,
											form as HTMLFormElement
										)
									}
									target="_blank"
								>
									<input
										type="hidden"
										name="searchCondition"
										value={`{"questionID":"${qid}","fileNum":"${fnum}","lang":"${
											this.props.userAttr.lang
										}","accessType":"10"}`}
									/>
									<input
										type="hidden"
										name="__tsqCookieName"
										value="TSQ_FD_0"
									/>
									<input
										type="hidden"
										name="__tsqFileType"
										value="testReferenceFile"
									/>
								</form>
							</div>
						);
					})}
				{answerForm}
				{isMultiPage && (
					<div className={classes.signControl}>
						<FormControlLabel
							control={
								<Checkbox
									checked={isSigned}
									onChange={this.handleSignQuestion(
										question.questionID
									)}
								/>
							}
							label={i18n.t('ELearningTestForm_0021')}
						/>
					</div>
				)}
			</div>
		);
	};

	/**
	 * 回答部radio形式
	 */
	protected AnswerFormRadio: React.FC<{
		question: Actions.IQuestion;
	}> = props => {
		const { question } = props;
		const answers = question.answers as Actions.IRadioAnswer[];
		const width: React.CSSProperties = {
			minWidth: '42px',
		};
		return (
			<React.Fragment>
				{answers.map((answer, i) => (
					<Grid
						key={i}
						container={true}
						spacing={2}
						alignItems="flex-start"
					>
						<Grid item={true} style={width}>
							<Typography>{answer.displayNum}</Typography>
						</Grid>
						<Grid item={true} xs={true}>
							<FormControl
								component="fieldset"
								className={this.props.classes.width}
							>
								<RadioGroup
									name={question.questionID}
									onChange={this.handleChangeRadio(
										question.questionID,
										i
									)}
									value={
										this.state.answers[question.questionID][
											i
										]
									}
								>
									{answer.options.map((option, j) => (
										<FormControlLabel
											key={j}
											className={
												this.props.classes
													.selectAndRadio
											}
											value={option.answerID}
											control={<Radio />}
											label={
												'' === option.answerID
													? i18n.t(
															option.answerText,
															{ ns: 'force' }
													  )
													: option.answerText
											}
										/>
									))}
								</RadioGroup>
							</FormControl>
						</Grid>
					</Grid>
				))}
			</React.Fragment>
		);
	};

	/**
	 * 回答部text形式
	 */
	protected AnswerFormText: React.FC<{
		question: Actions.IQuestion;
	}> = props => {
		const { question } = props;
		const { classes } = this.props;
		const answers = question.answers as Actions.ITextAnswer[];

		return (
			<form
				noValidate={true}
				autoComplete="off"
				className={classes.paddingLeft}
			>
				{answers.map((answer, i) => {
					const textFieldProps: TextFieldProps = {
						id: answer.answerID,
						label: answer.displayNum,
						margin: 'normal',
						value: this.state.answers[question.questionID][i],
					};
					if (question.questionTextNum) {
						// 半角数字入力
						textFieldProps.onChange = this.handleChangeNumberText(
							question.questionID,
							i
						);
						textFieldProps.helperText = i18n.t(
							'ELearningTestForm_0022'
						);
						textFieldProps.inputProps = {
							pattern: '\\d*',
						};
					} else {
						// 通常入力
						textFieldProps.onChange = this.handleChangeText(
							question.questionID,
							i
						);
					}
					return (
						<div key={answer.answerID}>
							<TextField {...textFieldProps} />
						</div>
					);
				})}
			</form>
		);
	};

	/**
	 * 回答部check形式
	 */
	protected AnswerFormCheck: React.FC<{
		question: Actions.IQuestion;
	}> = props => {
		const { question } = props;
		const { classes } = this.props;
		const answers = question.answers as Actions.ICheckAnswer[];
		return (
			<FormControl
				component="fieldset"
				className={this.props.classes.width}
			>
				<FormGroup>
					{answers.map((answer, i) => (
						<FormControlLabel
							key={i}
							value={answer.answerID}
							control={
								<Checkbox
									key={question.questionID}
									checked={
										this.state.answers[
											question.questionID
										].find(a => a === answer.answerID)
											? true
											: false
									}
								/>
							}
							label={answer.answerText}
							onChange={this.handleChangeCheck(
								question.questionID
							)}
							className={classes.checkbox}
						/>
					))}
				</FormGroup>
			</FormControl>
		);
	};

	/**
	 * 回答部select形式
	 */
	protected AnswerFormSelect: React.FC<{
		question: Actions.IQuestion;
	}> = props => {
		const { question } = props;
		const { classes } = this.props;
		const answers = question.answers as Actions.ISelectAnswer[];
		return (
			<form autoComplete="off" className={classes.paddingLeft}>
				{answers.map((answer, i) => (
					<div key={i}>
						<FormControl className={this.props.classes.width}>
							<InputLabel htmlFor={question.questionID}>
								{answer.displayNum}
							</InputLabel>
							<Select
								autoWidth={true}
								className={classes.minWidth}
								value={
									this.state.answers[question.questionID][i]
								}
								inputProps={{
									id: question.questionID,
									name: question.questionID,
								}}
								onChange={this.handleChangeSelect(
									question.questionID,
									i
								)}
								classes={{
									select: classes.selectAndRadio,
									selectMenu: this.props.classes.whiteSpace,
								}}
							>
								<MenuItem value="">
									<em>{i18n.t('ELearningTestForm_0023')}</em>
								</MenuItem>
								{answer.options.map((option, j) => (
									<MenuItem
										key={j}
										value={option.answerID}
										className={
											this.props.classes.selectAndRadio
										}
									>
										{option.answerText}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</div>
				))}
			</form>
		);
	};

	/**
	 * 添付資料ダウンロード用のフォームを保存
	 */
	protected addFileForm(
		questionID: string,
		index: number,
		form: HTMLFormElement
	) {
		if (!this.forms[questionID]) {
			this.forms[questionID] = {};
		}
		this.forms[questionID][index] = form;
	}

	/**
	 * 回答したかどうかのチェック
	 */
	protected isAnswered(question: Actions.IQuestion) {
		const { answers } = this.state;

		if (question.questionKind === Actions.QuestionKind.CHECK) {
			for (const a of answers[question.questionID]) {
				if (a !== '') {
					// check形式の場合はひとつでもチェックがあればOK
					return true;
				}
			}
			return false;
		}
		let yet = false;
		for (const a of answers[question.questionID]) {
			if (a === '') {
				yet = true;
				break;
			}
		}
		// check以外の形式のときはすべて回答した場合にOK
		return !yet;
	}

	/**
	 * ラジオボタン変更ハンドラ
	 */
	protected handleChangeRadio = (questionID: string, index: number) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		this.state.answers[questionID][index] = target.value;
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * テキスト変更ハンドラ
	 */
	protected handleChangeText = (questionID: string, index: number) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		if (target.value.length <= 2000) {
			this.state.answers[questionID][index] = target.value;
			this.setState({
				answers: this.state.answers,
			});
		}
	};

	/**
	 * 半角テキスト変更ハンドラ
	 */
	protected handleChangeNumberText = (questionID: string, index: number) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		const value = target.value.replace(/\D+/g, '');
		if (target.value.length <= 2000) {
			this.state.answers[questionID][index] = value;
			this.setState({
				answers: this.state.answers,
			});
		}
	};

	/**
	 * チェックボックス変更ハンドラ
	 */
	protected handleChangeCheck = (questionID: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		const answers = this.state.answers[questionID];
		const newAnswers = answers.filter(a => a !== target.value);
		if (target.checked) {
			newAnswers.push(target.value);
		}
		this.state.answers[questionID] = newAnswers;
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * プルダウン変更ハンドラ
	 */
	protected handleChangeSelect = (questionID: string, index: number) => (
		event: React.ChangeEvent<HTMLSelectElement>
	) => {
		const target = event.target as HTMLSelectElement;
		this.state.answers[questionID][index] = target.value;
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * 採点ボタン押下ハンドラ
	 */
	protected handleMarkTest = () => {
		let denominator = 0;
		let numerator = 0;
		for (const group of this.props.groups) {
			for (const question of group.questions) {
				denominator++;
				if (this.isAnswered(question)) {
					numerator++;
				}
			}
		}
		if (denominator === numerator) {
			this.handleStartMark();
		} else {
			this.setState({
				openMarkConfirm: true,
			});
		}
	};

	/**
	 * 採点確認ダイアログクローズハンドラ
	 */
	protected handleCloseConfirmMark = () => {
		this.setState({
			openMarkConfirm: false,
		});
	};

	/**
	 * 採点開始
	 */
	protected handleStartMark = () => {
		this.setState({
			disableMarkButton: true,
			openMarkConfirm: false,
		});

		if (!this.props.currentTreeItem) {
			return;
		}
		// 受講画面が読み込みの状態を有効化
		this.props.setProgressLoadingFlg(true);
		const testID = this.props.currentTreeItem.id;
		const testStyle = this.props.currentTreeItem.displayStyle;
		let markTest: Promise<any>;
		if (this.props.currentTreeItem.displayStyle !== 0) {
			markTest = this.props.markTestStep(this.props.token, {
				answers: this.state.answers,
				careerID: this.props.careerID,
				classID: this.props.classID,
				examStartTime: this.props.examStartTime,
				groups: this.props.groups,
				isPreview: this.props.preview,
				signedQuestionIDs: this.state.signedQuestionIDs,
				startTime: this.props.startTime,
				testID,
				thistoryID: this.props.thistoryID,
				userAttr: this.props.userAttr,

				cnt: this.props.cnt,
				dbms: this.props.dbms,
				groupCount: this.props.groupCount,
				markAfter: this.props.markAfter,
				questionGroupDisplay: this.props.questionGroupDisplay,
				retries: this.props.retries,
				testSetQuizCount: this.props.testSetQuizCount,
				timeLimit: this.props.timeLimit,
			});
		} else {
			markTest = this.props.markTest(this.props.token, {
				answers: this.state.answers,
				careerID: this.props.careerID,
				classID: this.props.classID,
				examStartTime: this.props.examStartTime,
				groups: this.props.groups,
				isPreview: this.props.preview,
				signedQuestionIDs: this.state.signedQuestionIDs,
				startTime: this.props.startTime,
				testID,
				thistoryID: this.props.thistoryID,
				userAttr: this.props.userAttr,

				cnt: this.props.cnt,
				dbms: this.props.dbms,
				groupCount: this.props.groupCount,
				markAfter: this.props.markAfter,
				questionGroupDisplay: this.props.questionGroupDisplay,
				retries: this.props.retries,
				testSetQuizCount: this.props.testSetQuizCount,
				timeLimit: this.props.timeLimit,
			});
		}

		markTest
			.then(async result => {
				// メッセージコードが指定されている場合はメッセージを表示し、ダイアログを閉じた際に次の画面へ遷移する
				if (
					(result.messageCode && result.messageCode.length > 0) ||
					result.tsqId === null
				) {
					// this.setState({
					// 	openNoticeLaterOn: true,
					// });
					this.getIsLastItem();
					this.props.getScoringButtonClickResult(result);
				} else {
					// インデックスツリー取得
					await this.props
						.fetchELearningTree(this.props.token, {
							careerID: this.props.careerID,
							classID: this.props.classID,
							isPreview: this.props.preview,
							userAttr: this.props.userAttr,
						})
						.then(() => {
							// ツリーを移動して結果を表示
							this.props.setELearningTreeItemTestLog(
								testID,
								this.props.thistoryID,
								testStyle
							);
						});

					// 進捗率更新
					this.props.fetchELearningProgress(this.props.token, {
						careerID: this.props.careerID,
						classID: this.props.classID,
						isPreview: this.props.preview,
						userId: this.props.userAttr.userId,
					});
				}
			})
			.finally(() => {
				// 受講画面が読み込みの状態を表示しない
				this.props.setProgressLoadingFlg(false);
			});
	};

	protected getIsLastItem = async () => {
		const next = this.props.getNextTreeItem();
		if (!next) {
			// 最終ページ
			// this.props.showELearningFinishDialog(true);
			this.setState({ openNoticeLaterOn: true });
		} else {
			await this.props.fetchELearningTree(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				userAttr: this.props.userAttr,
			});
			// 進捗率更新
			this.props.fetchELearningProgress(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				userId: this.props.userAttr.userId,
			});
			this.setState({ openNoticeLaterOn: true });
		}
	};

	/**
	 * 一時保存ボタン押下ハンドラ
	 */
	protected handleSaveTest = () => {
		if (this.props.preview) {
			this.setState({
				disableMarkButton: false,
				saveResultSnackbar: true,
			});
			return;
		}
		this.setState({
			disableMarkButton: true,
		});

		if (!this.props.currentTreeItem) {
			return;
		}
		this.props
			.saveTest(this.props.token, {
				answers: this.state.answers,
				careerID: this.props.careerID,
				classID: this.props.classID,
				cnt: this.props.cnt,
				dbms: this.props.dbms,
				examStartTime: this.props.examStartTime,
				groupCount: this.props.groupCount,
				groups: this.props.groups,
				isPreview: this.props.preview,
				markAfter: this.props.markAfter,
				questionGroupDisplay: this.props.questionGroupDisplay,
				retries: this.props.retries,
				signedQuestionIDs: this.state.signedQuestionIDs,
				startTime: this.props.startTime,
				testID: this.props.currentTreeItem.id,
				testSetQuizCount: this.props.testSetQuizCount,
				thistoryID: this.props.thistoryID,
				timeLimit: this.props.timeLimit,
				userAttr: this.props.userAttr,
			})
			.then(result => {
				this.setState({
					disableMarkButton: false,
					saveResultSnackbar: true,
				});
			});
	};

	/**
	 * 一問一ページ形式で見出しをクリックしたときのハンドラ
	 */
	protected handleSelectQuestion = (
		group: number,
		question: number
	) => () => {
		this.setState({
			selectedGroup: group,
			selectedQuestion: question,
		});
	};

	/**
	 * 一時保存後のSnackbarクローズハンドラ
	 */
	protected handleSaveResultSnackbarClose = (event: any, reason: any) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ saveResultSnackbar: false });
	};

	/**
	 * ファイルダウンロード用ハンドラ
	 */
	protected handleFileChip = (questionID: string, index: number) => () => {
		const form = this.forms[questionID][index];
		form.submit();
	};

	/**
	 * 5分前ダイアログのクローズハンドラ
	 */
	protected handleClose5Minutes = () => {
		this.setState({ open5Minutes: 'done' });
	};

	/**
	 * タイムアップダイアログのクローズハンドラ
	 */
	protected handleTimeup = () => {
		this.handleStartMark();
		this.setState({ openTimeup: false });
	};

	/**
	 * 「この設問にチェックをいれる」ハンドラ
	 */
	protected handleSignQuestion = (questionID: string) => () => {
		if (this.state.signedQuestionIDs.has(questionID)) {
			this.state.signedQuestionIDs.delete(questionID);
		} else {
			this.state.signedQuestionIDs.add(questionID);
		}
		this.setState({ signedQuestionIDs: this.state.signedQuestionIDs });
	};

	/**
	 * 後日採点通知ダイアログクローズハンドラ
	 */
	protected handleCloseNoticeLaterOn = () => {
		this.setState({ openNoticeLaterOn: false, disableMarkButton: false });
		const next = this.props.getNextTreeItem();
		if (!this.props.elearingUpdateResult) {
			return;
		}

		if (
			this.props.markAfter &&
			!next &&
			this.props.elearingUpdateResult.tsqId === null
		) {
			this.props.showELearningFinishDialog(true);
		} else {
			this.props.clearElearingUpdateResult();
			this.props.handleNext();
		}
	};

	/**
	 * 表示情報取得
	 */
	protected fetch() {
		this.props.clearTestFormParams();
		if (!this.props.currentTreeItem) {
			return;
		}
		if (this.props.currentTreeItem.displayStyle === 0) {
			this.props.fetchTestCollect(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				testID: this.props.currentTreeItem.id,
				userAttr: this.props.userAttr,
			});
		} else {
			this.props.fetchTestStep(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				testID: this.props.currentTreeItem.id,
				userAttr: this.props.userAttr,
			});
		}
	}

	/**
	 * タイマ開始
	 */
	protected startCountdown() {
		this.startAt = new Date();
		this.countdown();
	}

	/**
	 * タイマ終了
	 */
	protected endCountdown() {
		if (this.timer !== undefined) {
			clearTimeout(this.timer);
		}
	}

	/**
	 * 制限時間更新ハンドラ
	 */
	protected countdown() {
		const now = Date.now();
		const limitAt = this.startAt.getTime() + this.props.timeLimit * 60000;

		// 残り時間の計算
		const secondsToGo =
			limitAt - now < 0 ? 0 : Math.floor((limitAt - now) / 1000);
		this.setState({ secondsToGo });

		if (limitAt - now < 0) {
			// タイムアップ
			this.setState({
				open5Minutes: 'done',
				openTimeup: true,
			});
			return;
		}
		if (
			this.state.open5Minutes === 'yet' &&
			this.props.timeLimit > 5 &&
			limitAt - now < 300000
		) {
			// 5分前
			this.setState({ open5Minutes: 'doing' });
		}

		// 次回起動タイマ 終了時刻からキリのよい時刻を狙う
		const target = limitAt - secondsToGo * 1000 + 1; // 目標 n.999秒前
		const delay = target - now;
		this.timer = window.setTimeout(() => this.countdown(), delay);
	}

	/**
	 * 秒 → mmm:nn変換
	 */
	protected secondsToStrings(seconds: number) {
		const minutesStrings = (
			'00' + Math.floor(seconds / 60).toString()
		).slice(-3);
		const secondsStrings = ('0' + (seconds % 60).toString()).slice(-2);
		return `${minutesStrings}:${secondsStrings}`;
	}
}

const mapStateToProps = (state: IRootState) => ({
	displayTmpSaveBtn: state.testForm.displayTmpSaveBtn,
	examStartTime: state.testForm.examStartTime,
	groups: state.testForm.groups,
	markAfter: state.testForm.markAfter,
	questionGroupDisplay: state.testForm.questionGroupDisplay,
	retries: state.testForm.retries,
	startTime: state.testForm.startTime,
	testSetQuizCount: state.testForm.testSetQuizCount,
	thistoryID: state.testForm.thistoryID,
	timeLimit: state.testForm.timeLimit,

	currentTreeItem: state.eLearning.currentTreeItem,

	token: state.session.token,
	userAttr: state.session.userAttr,

	cnt: state.testForm.cnt,
	dbms: state.testForm.dbms,
	groupCount: state.testForm.groupCount,

	elearingUpdateResult: state.eLearning.elearingUpdateResult,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearElearingUpdateResult: () => dispatch(clearElearingUpdateResult()),
	clearTestFormParams: () => dispatch(Actions.clearTestFormParams({})),
	fetchELearningProgress: (
		token: string,
		arg: IFetchELearningProgressParam
	) => {
		const s = ELearningScenarioFactory.createFetchELearningProgress(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ELearningScenarioFactory.createFetchELearningTree(
			dispatch,
			token
		);
		return s.run(arg);
	},
	fetchTestCollect: (token: string, arg: IFetchTestParam) => {
		const s = ScenarioFactory.createFetchTestCollect(dispatch, token);
		s.run(arg);
	},
	fetchTestStep: (token: string, arg: IFetchTestParam) => {
		const s = ScenarioFactory.createFetchTestStep(dispatch, token);
		s.run(arg);
	},
	markTest: (token: string, arg: IMarkTestParms) => {
		const s = ScenarioFactory.createMarkTest(dispatch, token);
		return s.run(arg);
	},
	markTestStep: (token: string, arg: IMarkTestParms) => {
		const s = ScenarioFactory.createMarkTestStep(dispatch, token);
		return s.run(arg);
	},
	saveTest: (token: string, arg: IMarkTestParms) => {
		const s = ScenarioFactory.createSaveTest(dispatch, token);
		return s.run(arg);
	},
	setELearningNextOrTopITem: () => dispatch(setELearningNextOrTopITem({})),
	setELearningTreeItemTestLog: (
		testID: string,
		thistoryID: number,
		displayStyle: number
	) =>
		dispatch(
			setELearningTreeItemTestLog({ testID, thistoryID, displayStyle })
		),

	showELearningFinishDialog: (isOpen: boolean) =>
		dispatch(showELearningFinishDialog({ isOpen })),

	setELearningReservedTreeItem: (item: IIndexTreeItem) =>
		dispatch(setELearningReservedTreeItem({ item })),
	setNotMarkCompleteFlg: () => dispatch(setNotMarkCompleteFlg()),

	getScoringButtonClickResult: (
		elearingUpdateResult: IScoringButtonClickSaveResult | undefined
	) => dispatch(getScoringButtonClickResult({ elearingUpdateResult })),
});

export interface IELearningTestFormProps extends IELearningCommonProps {
	getNextTreeItem: () => IIndexTreeItem | null;
	handleNext: () => void;
	handlePrev: () => void;
	onRef: (view: object) => void;
	updateState: () => void;
	setProgressLoadingFlg: (progressLoadingFlg: boolean) => void;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IELearningTestFormProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ELearningTestForm);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ELearningTestForm.tsx